import { Component, OnInit, Input } from '@angular/core';
import { Helper } from '../../helper';
import { CartService } from '../../api';
import { MdDialogRef, MdDialog } from '@angular/material';
import { SongDetailComponent } from '../../songs/song-detail/song-detail.component';

@Component({
  selector: 'cart-item',
  templateUrl: './cart-item.component.html',
  styleUrls: ['./cart-item.component.css']
})
export class CartItemComponent implements OnInit {
  private helper = new Helper();
  @Input() item: any;
  public product: any;
  dialogRef: MdDialogRef<SongDetailComponent>;
  constructor(private cartService: CartService, public dialog: MdDialog) { }

  ngOnInit() {
    this.product = this.item.product;
  }

  openSongDetail(slug: any) {
    var width = '', height = '';
    var browserZoomLevel = Math.round(window.devicePixelRatio * 100);
    width = '37%';
    this.dialogRef = this.dialog.open(SongDetailComponent, {
      width: width
    });
    this.dialogRef.componentInstance.slug = slug;
    return false;
  }

  deleteProduct(event) {
    event.stopPropagation();
    event.preventDefault();
    this.cartService.removeItem(this.item);
  }

}



// WEBPACK FOOTER //
// ./src/app/cart/cart-item/cart-item.component.ts